import { axiosInstance } from "../../utils/axios";
import { LinkedDocumentInfo } from "../models/linked-document-info";
import { TgkSendToInDesignElaborationRequest } from "../models/tgk-send-to-in-design-elaboration-request";
import { store } from "../../redux/store/store";
import { selectCpmUsername } from "../../redux/feature/settings/configurations-slice";
import { DocPropKeys, retrieveDocumentProp, setDocumentProp } from "../../utils/helpers/CustomXmlHelper";
import { EVENT_CHANNEL_DEFAULT_TOPIC } from "../../utils/constants/eventChannel";
import { DocumentPart } from "../models";
import * as uuid from "uuid";
import { FileInfo } from "../models/file-info";
import { AxiosCustomParams } from "../../utils/helpers/axios.helpers";

export const INDESIGN_LINK_NAME_PREFIX = "InDesign - ";
export const INDESIGN_FOLDER_NAME = "InDesign";

export async function isInDesignEnabled(): Promise<boolean> {
  const prop = await retrieveDocumentProp(DocPropKeys.IsInDesignEnabled);
  return prop?.toLowerCase() === "true";
}

export async function setInDesignEnabled(enabled: boolean): Promise<void> {
  return setDocumentProp(DocPropKeys.IsInDesignEnabled, enabled.toString());
}

export async function sendDocumentToInDesign(data: DocumentPart) {
  const storeData = store.getState();
  const clientId = storeData.configurationState.clientId;
  const username = selectCpmUsername(storeData);
  const channel = await retrieveDocumentProp(DocPropKeys.DocumentId);
  console.log("channel", channel);

  const payload: TgkSendToInDesignElaborationRequest = {
    correlationId: uuid.v4(),
    clientId: clientId,
    userId: username,
    typeElaborationRequest: "tgkSendToInDesignElaborationRequest",
    channelIdToNotify: channel || EVENT_CHANNEL_DEFAULT_TOPIC,
    documentId: data.id,
  };

  return axiosInstance
    .post(`sendToInDesign`, payload, { params: { generatesElaboration: true } })
    .then((resp) => resp.data);
}

export async function fetchInDesignLinkedDocument(
  documentId: string,
  config?: { params?: AxiosCustomParams }
): Promise<LinkedDocumentInfo> {
  try {
    const resp = await axiosInstance.get(`/indesignlinkeddocument/${documentId}/info`, config);
    return resp.data;
  } catch (reason) {
    console.error("Error on fetching InDesign Linked Document", reason);
    return null;
  }
}

export async function fileExists(
  path: string,
  fileName: string,
  config?: {
    params?: AxiosCustomParams;
  }
): Promise<boolean> {
  const payload: FileInfo = {
    path,
    fileName,
  };

  const resp = await axiosInstance.post(`/sharepoint/fileexists`, payload, config);
  return resp.data;
}
